const subsidyDate = {
  VALUE: 'value',
};

export default subsidyDate;
